var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search',{attrs:{"p_searchType":_vm.d_searchType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }